import { Component, EventEmitter, Input, OnInit, Optional, Output, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { IonicComponentsModule } from 'src/app/modules/ionic-components.module';

@Component({
  selector: 'fv-radiogroup',
  templateUrl: './radiogroup.component.html',
  styleUrls: ['./radiogroup.component.scss'],
  standalone: true,
  imports: [
    IonicComponentsModule
  ]
})
export class RadiogroupComponent  implements ControlValueAccessor {

  //#region Propiedades

  @Input("label") public label: string
  @Input("value-field") public valueField: string = 'Id'
  @Input("display-field") public displayField: string = 'Text'
  @Input("data-source") public dataSource: BehaviorSubject<any[]>
  @Input("readonly") public readonly: boolean
  @Input("obligatorio") public obligatorio: boolean // Esto es solo para pintar un asterisco, y este campo no se lee de los validadores, sino que hay que establecerlo a mano.

  private _value: any
  public get value(): any {
    return this._value
  }
  @Input("value") public set value(val: any) {
    if (this._value !== val) {
      this._value = val
    }
  }
  @Output("valueChange") public valueChange = new EventEmitter<any>()
  @Output("valueSelected") public valueSelected = new EventEmitter<{newValue: string, oldValue: string}>()

  //#endregion

  //#region Constructor

  constructor(
    @Self() @Optional() private control: NgControl
  ) {
    if (this.control != null) this.control.valueAccessor = this
  }

  //#endregion

  //#region Eventos

  public optionSelected(option: any): void {
    let oldValue = this._value
    if (option == null) {
      this.value = ''
    } else {
      this.value = option.toString()
    }
    this.valueChange.emit(this.value)
    this.valueSelected.emit({newValue: this.value, oldValue: oldValue})
    this.onChange(this.value)
    this.onTouched()
  }

  //#endregion

  //#region Reactive Forms

  private onChange = (value: any) => { }
  private onTouched = () => { }

  writeValue(value: any): void {
    this.value = value
    this.valueChange.emit(value)
    this.onChange(value)
  }

  registerOnChange(fn: (value: any) => {}): void {
    this.onChange = fn
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn
  }

  public isInvalid(): boolean {
    return this.control ? this.control.invalid : false
  }

  public isTouched(): boolean {
    return this.control ? this.control.touched : false
  }

  //#endregion

}
